@if (vm$ | async; as vm) {
  @if (headerShown) {
    <mat-toolbar id="navbar" class="navbar-top">
      <div class="container">
        <div class="d-flex flex-row">
          <a class="left-content logo" routerLink="/e-learning/trainings/available">
            <img src="assets/img/troodi-dark_v2.svg" alt="troodi Logo" class="header-logo" />
          </a>
          @if (!blankHeader) {
            <!-- logged-in users have navigation and menu-button -->
            @if ((user$ | async); as user) {
              <!-- navigation-links -->
              <div class="nav-links d-none d-lg-flex mx-3 align-self-center">
                @if (user.has_dep_projects) {
                  <a
                    class="textlink mx-3"
                    [class.highlighted]="vm.currentNav === 'e-learning-journeys'"
                    routerLink="/e-learning/e-learning-journeys"
                    translate>
                    NAVBAR.DEP_PROJECTS
                  </a>
                }
                @if (user.has_learning_paths) {
                  <a
                    class="textlink mx-3"
                    [class.highlighted]="vm.currentNav === 'learningpaths'"
                    routerLink="/e-learning/learningpaths"
                    translate>
                    NAVBAR.LEARNINGPATHS
                  </a>
                }
                <a
                  class="textlink mx-3"
                  routerLink="/e-learning/trainings/available"
                  [class.highlighted]="vm.currentNav === 'trainings'"
                  translate>
                  NAVBAR.TRAININGS.MAIN
                </a>
              </div>
              <!-- menu-button -->
              <div class="d-none d-lg-flex align-self-center flex-grow-1 justify-content-end">
                <div class="badge-wrapper">
                  <div
                    class="me-4"
                    [class.interactive]="showExpirationNotification"
                    matBadge="!"
                    [matBadgeHidden]="!showExpirationNotification"
                    [matBadgeDescription]="'EXPIRED_USER.MENU_ITEM' | translate"
                    matBadgeSize="small"
                    matBadgeColor="accent"
                    matBadgeOverlap="true"
                    [matTooltip]="'EXPIRED_USER.MENU_ITEM' | translate"
                    [matTooltipDisabled]="!showExpirationNotification"
                    matTooltipPosition="below"
                    matTooltipClass="primary-tooltip"
                  (click)="showExpirationInformation()"></div>
                  <div class="user-menu-icon" aria-label="User menu" [matMenuTriggerFor]="userMenu">
                    @if (user$ | async; as user) {
                      @if (user.first_name && user.last_name) {
                        <span>{{getUserInitials(user)}}</span>
                      } @else {
                        <mat-icon svgIcon="trainer_v2"></mat-icon>
                      }
                    }
                  </div>
                </div>
                <mat-menu #userMenu="matMenu">
                  <a routerLink="/settings" mat-menu-item>
                    <span translate>NAVBAR.MY_PROFILE</span>
                  </a>
                  <a href="/sign_out" mat-menu-item>
                    <span translate>NAVBAR.LOGOUT</span>
                  </a>
                </mat-menu>
              </div>
            }
            <!-- Visitors can change language and are prompted to sign up -->
            @if (!(user$ | async)) {
              <div
                class="d-none d-lg-flex align-self-center text-end flex-grow-1 align-items-center justify-content-end">
                <span class="language-selection me-4">
                  <button mat-button type="button" (click)="openLanguageDialog()">
                    <mat-icon svgIcon="language_v2" class="me-2"></mat-icon>
                    <span>{{ languageMapping[getCurrentLanguage] }}</span>
                  </button>
                </span>
                <a mat-flat-button class="nav-button" routerLink="signup" color="primary">
                  <span translate>SIGNUP.BUTTON</span>
                </a>
              </div>
            }
            <!-- Burger-Menu for small devices, if user is not active: show badge on the menu -->
            <div
              class="d-flex d-lg-none align-self-center text-end collapse-menu flex-grow-1 justify-content-end"
              matBadge="!"
              [matBadgeHidden]="!showExpirationNotification"
              [matBadgeDescription]="'EXPIRED_USER.MENU_ITEM' | translate"
              matBadgeSize="small"
              matBadgeColor="accent">
              <mat-icon
                svgIcon="menu_v2"
                class="collapse-menu-icon"
                [matMenuTriggerFor]="collapseMenu"
              aria-label="Collapsible menu"></mat-icon>
              <mat-menu #collapseMenu="matMenu">
                <!-- Menu-Items for logged-in users -->
                @if ((user$ | async); as user) {
                  <!-- If the user is expired, show an extra menu-item for this -->
                  @if (showExpirationNotification) {
                    <button (click)="showExpirationInformation()" mat-menu-item>
                      <span class="highlighted" translate>EXPIRED_USER.MENU_ITEM</span>
                    </button>
                  }
                  @if (user.has_dep_projects) {
                    <a routerLink="/e-learning/e-learning-journeys" mat-menu-item>
                      <span translate>NAVBAR.DEP_PROJECTS</span>
                    </a>
                  }
                  @if (user.has_learning_paths) {
                    <a routerLink="/e-learning/learningpaths" mat-menu-item>
                      <span translate>NAVBAR.LEARNINGPATHS</span>
                    </a>
                  }
                  <button [matMenuTriggerFor]="trainingsSubMenu" mat-menu-item>
                    <span translate>NAVBAR.TRAININGS.MAIN</span>
                  </button>
                  <a routerLink="/settings" mat-menu-item>
                    <span translate>NAVBAR.MY_PROFILE</span>
                  </a>
                  <a href="/sign_out" mat-menu-item>
                    <span translate>NAVBAR.LOGOUT</span>
                  </a>
                }
                <!-- Menu-Items for visitors -->
                @if (!(user$ | async)) {
                  <!-- No Self-Signup currently -->
                  <a mat-menu-item routerLink="signup" color="accent">
                    <span translate>SIGNUP.BUTTON</span>
                  </a>
                  <a mat-menu-item (click)="openLanguageDialog()">
                    <mat-icon svgIcon="language_v2" class="me-2"></mat-icon>
                    <span>{{ languageMapping[getCurrentLanguage] }}</span>
                  </a>
                }
              </mat-menu>
              <mat-menu #trainingsSubMenu="matMenu">
                <a routerLink="/e-learning/trainings/all" mat-menu-item>
                  <span translate>NAVBAR.TRAININGS.ALL</span>
                </a>
                <a routerLink="/e-learning/trainings/available" mat-menu-item>
                  <span translate>NAVBAR.TRAININGS.AVAILABLE</span>
                </a>
                <a routerLink="/e-learning/trainings/grouped" mat-menu-item>
                  <span translate>NAVBAR.TRAININGS.GROUPED</span>
                </a>
              </mat-menu>
            </div>
          }
        </div>
      </div>
    </mat-toolbar>
  }
  <!-- Use native mat-progress-bar as base for ngx-loading-bar for coherent styling -->
  @if (loader.value$ | async; as loadingValue) {
    <!--  TODO: If >ng16, the newest loading-bar has the option to specify a latency before showing the loading bar, which we should set >100ms  -->
    <mat-progress-bar
      class="loading-bar"
      [ngClass]="!headerShown ? 'loading-bar-top' : ''"
      color="accent"
      mode="determinate"
    [value]="loadingValue"></mat-progress-bar>
  }
  @if (showOnboarding$ | async) {
    <app-onboarding></app-onboarding>
  }
  <!-- Custom launcher for support-contact -->
  @if (!hideContactFloat) {
    <app-contact-float [user]="user$ | async" (openOnboardingTour)="openOnboardingTour()"></app-contact-float>
  }
  <div [class.splash]="splashShown" [class.main]="headerShown" [class.main-without-header]="!headerShown" #appContainer cdkScrollable>
    <div class="main-content">
      <router-outlet class="outer-router-outlet" #outlet="outlet"></router-outlet>
    </div>
    @if (headerShown) {
      <footer>
        <mat-toolbar class="footer d-flex flex-column justify-content-between">
          <div
            class="footer-top container-max d-flex flex-row flex-grow-1 justify-content-start justify-content-md-between align-items-start align-items-md-end">
            <div class="d-flex flex-column contact-wrapper">
              <div>
                <!--TODO: restructure the icons! We now have two SVGs: de and dark, as well as a png that is basically the dark one -->
                <img src="assets/img/troodi-de_v2.svg" alt="troodi Logo" class="footer-logo" />
              </div>
              <div class="contact d-flex flex-column flex-md-row">
                <address class="d-flex flex-column">
                  <a href="mailto:info@troodi.de">info&#64;troodi.de</a>
                  <a href="tel:+4922156095669">+49 221 56095669</a>
                  <a href="https://troodi.de">troodi.de</a>
                </address>
                <address class="d-flex flex-column">
                  <span>troodi GmbH</span>
                  <span>Lichtstr. 25</span>
                  <span>50825 Köln </span>
                </address>
              </div>
            </div>
            <div class="d-flex social">
              <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/troodi-gmbh/">
                <mat-icon svgIcon="linkedin_v2"></mat-icon>
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.xing.com/companies/troodigmbh">
                <mat-icon svgIcon="xing_v2"></mat-icon>
              </a>
            </div>
          </div>
          <div class="container-max legal d-flex flex-row justify-content-center align-items-baseline">
            <a href="https://troodi.de/impressum/">
              <span translate>FOOTER.IMPRINT</span>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://troodi.de/impressum/#ds">
              <span translate>FOOTER.PRIVACY_POLICY</span>
            </a>
            <a (click)="openCookieDialog()">
              <span translate>FOOTER.COOKIES</span>
            </a>
          </div>
        </mat-toolbar>
      </footer>
    }
  </div>
}
